import { ResetPasswordForm } from '@/features/auth/ui/ResetPasswordForm';

export const ResetPassword = () => {
  return <ResetPasswordForm />;
};
